import { useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';

/**
 * Custom hook to access theme context
 * @throws {Error} If used outside of ThemeProvider
 * @returns {{ theme: 'light' | 'dark', setTheme: (theme: 'light' | 'dark') => void, toggleTheme: () => void }}
 */
const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error(
      'useTheme must be used within a ThemeProvider. ' +
      'Wrap your component tree with <ThemeProvider>.'
    );
  }
  return context;
};

export default useTheme;
